import { useMemo } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { GridColDef } from '@mui/x-data-grid';
import Chip from '@mui/material/Chip';
import { QualificationListItem } from '@libs/models/qualifications';

export function useQualificationsSettingsColumns({ localizationSubset }: { localizationSubset: string }) {
  const intl = useIntl();
  // Columns should be memoized to prevent table flickering and state loss
  return useMemo(() => {
    const columns: GridColDef<QualificationListItem>[] = [
      getNameColumn(intl, localizationSubset),
      getAbbreviationColumn(intl, localizationSubset),
      getCategoryColumn(intl, localizationSubset),
    ];
    return columns;
  }, [intl]);
}

function getNameColumn(intl: IntlShape, localizationSubset: string): GridColDef<QualificationListItem> {
  return {
    field: 'name',
    headerName: intl.formatMessage({ id: `${localizationSubset}.table.fields.qualification.heading` }),
    minWidth: 160,
    resizable: true,
    display: 'flex',
    flex: 1,
    sortable: true,
    filterable: false,
  };
}

function getAbbreviationColumn(intl: IntlShape, localizationSubset: string): GridColDef<QualificationListItem> {
  return {
    field: 'abbreviation',
    headerName: intl.formatMessage({
      id: `${localizationSubset}.table.fields.abbreviation.heading`,
    }),
    width: 160,
    renderCell: (params) => {
      if (!params.row) {
        return null;
      }
      const row = params.row as QualificationListItem;
      return <Chip label={row.abbreviation} />;
    },
  };
}

function getCategoryColumn(intl: IntlShape, localizationSubset: string): GridColDef<QualificationListItem> {
  return {
    field: 'category',
    headerName: intl.formatMessage({ id: `${localizationSubset}.table.fields.category.heading` }),
    minWidth: 160,
    resizable: true,
    display: 'flex',
    flex: 1,
    sortable: true,
    filterable: false,
  };
}
